<template>
  <el-card class="service" :body-style="{ 'padding-bottom': $slots.footer ? 0 : '20px' }">
    <div class="service__wrapper">
      <div class="icon" v-if="service.icon">
        <font-awesome-icon :icon="['fal', service.icon]" />
      </div>
      <div class="body">
        <h4 class="body__title">
          <span class="body__title__text">{{ service.title }}</span>
          <span  class="body__title__price">
            <template v-if="service.priceLabel || service.step">
              {{ $t('services.price.label',
              { exclTax: $t('base.priceType', priceTypeKey),
                price: $n(typePrice || 0, 'currency'),
                step: !service.priceLabel && service.step > 1 ? service.step : '',
                unity: service.priceLabel || service.title}) }}
            </template>
            <template v-else>
              {{ $t('services.price.labelOneUnit',
              { exclTax: $t('base.priceType', priceTypeKey),
                price: $n(typePrice || 0, 'currency')}) }}
            </template>
          </span>
        </h4>
        <h4 class="body__subtitle">
          {{ service.subtitle }}
        </h4>
        <slot name="body"></slot>
        <p v-html="service.text">
        </p>
        <slot name="message-error"></slot>
      </div>
      <div class="service__wrapper__price">
        <service-price :price="price" />
      </div>
      <h3></h3>
    </div>
    <slot name="options"></slot>
    <service-footer v-if="$slots.footer">
      <template #footer>
        <div class="service__footer">
          <slot name="footer">
          </slot>
        </div>
      </template>
    </service-footer>
  </el-card>
</template>

<script>
import { mapState } from 'pinia';
import ServiceFooter from '@/components/services/serviceFragment/Footer.vue';
import ServicePrice from '@/components/services/serviceFragment/Price.vue';
import { useDemandStore } from '@/stores';

export default {
  name: 'serviceWrapper',
  components: {
    ServiceFooter,
    ServicePrice,
  },
  props: {
    service: {
      type: Object,
    },
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    exclTax() {
      return this.demand.show_price_ht;
    },
    priceTypeKey() {
      return this.demand.priceTypeKey;
    },
    typePrice() {
      return this.service[this.demand.show_price_ht ? 'price_ht' : 'price'];
    },
    price() {
      if (this.service.step && this.service.enabled) {
        return this.service.value_chosen
          // eslint-disable-next-line no-mixed-operators
          ? this.service.value_chosen / this.service.step * this.typePrice : 0;
      }
      return this.service.is_chosen ? this.typePrice : 0;
    },
  },
};
</script>

<style scoped lang="scss">
.service {
  &__wrapper {
    display: flex;
    flex-direction: column;
    @include breakpoint(tablet) {
      flex-direction: row;
    }
    .icon {
      text-align: center;
      font-size: 40px;
    }
    .body {
      flex: 2;
      @include breakpoint(tablet) {
        padding: 0 20px;
      }
      &__title {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &__subtitle {
        font-weight: normal;
      }
    }
    &__price {
      justify-content: center;
      @include breakpoint(tablet) {
        width: 27%;
        max-width: 300px;
        min-width: 150px;
      }
    }
  }
  &__footer {
    margin-bottom: 20px;
  }
}
</style>
